import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';

const Specification = ({
  hoursPrior,
  destinations,
  notes,
  reroute,
  openTicketExpiryPolicy,
  translations
}) => {
  const {openPolicyTicket, openPolicyDestinations, openPolicySpecNotes,
    openPolicySameCompany, ticketValidity, ableToReverse} = translations;

  return (
    <Fragment>
      <li>
        {
          `${openPolicyTicket}
            ${destinations.length > 0 ? ` ${openPolicyDestinations}` : ''}
            ${notes ? ` ${openPolicySpecNotes}` : ''}`
            .replace('{hours}', hoursPrior)
            .replace('{destinations}', destinations.join(', '))
            .replace('{notes}', notes)
        }
      </li>
      {openTicketExpiryPolicy && <li>{`${ticketValidity}: ${openTicketExpiryPolicy}`}</li>}
      <li>{openPolicySameCompany}</li>
      {reroute === '1' && <li>{ableToReverse}</li>}
    </Fragment>
  );
};

Specification.propTypes = {
  hoursPrior: PropTypes.string.isRequired,
  destinations: PropTypes.object.isRequired,
  notes: PropTypes.string.isRequired,
  reroute: PropTypes.bool.isRequired,
  openTicketExpiryPolicy: PropTypes.string.isRequired,
  translations: PropTypes.shape({
    openPolicyTicket: PropTypes.string.isRequired,
    openPolicyDestinations: PropTypes.string.isRequired,
    openPolicySpecNotes: PropTypes.string.isRequired,
    openPolicySameCompany: PropTypes.string.isRequired,
    ticketValidity: PropTypes.string.isRequired,
    ableToReverse: PropTypes.string.isRequired
  }).isRequired
};

export default observer(Specification);
